import { useContext } from 'react';
import '../../style/components/header.css';
import Search from './search';
import { switchh } from '../../context/switch';
import LogoWork from '../global/logoWork';
import { auth } from '../../context/auth';
import { useTranslation } from 'react-i18next';
import BackIcon from "../../docs/light/home.png"
import { Link } from 'react-router-dom';
export default function Header() {
    const { t } = useTranslation()
    const { setEnableAttendance } = useContext(switchh);
    const { user } = useContext(auth);
    return (
        <header className='flex flex-space-bet'>
            <div className='flex flex-align-item-center'>
                <div className="logo">
                    <LogoWork logo={user.data[0].logo} width="150px" height='50px'/>
                </div>
                <Search />
                <div className='attendance'>
                    <button onClick={() => setEnableAttendance(true)}>{t("common:AttendanceTrackingBtn")}</button>
                </div>
                <button>
                    <Link to={'/'}><img src={BackIcon} alt="Back" width={'20'} /></Link>
                </button>
            </div>
        </header>
    )
}